import { Component } from "react";
import { Card, Row, Col, Tab, Tabs, Spinner, Button, Alert, Form } from "react-bootstrap";
import api from "../../services/api";
import { perguntasDaCategoria } from '../../common/config';
import { withRouter } from '../../common/with-router';
import { formataDataHoraExibicao, replaceTextVariables } from '../../common/utils';
import { FaDownload, FaExclamationTriangle, FaCheck } from "react-icons/fa";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import logomarca from '../../assets/images/logomarca.png';

import { getConfig } from "../../common/config";

/**
 * Componente de aceite de termos para médicos/prestadores.
 * Utiliza autenticação via X-USERNAME (sem login) e layout com tabs igual TermosMedicos.
 * Rota: /termos-medico/aceite/:uuid
 */
class TermosMedicoAceite extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loadingPdf: {
                termo: true,
                regulamento: true,
                privacidade: true,
                cookies: true
            },
            titulo_pagina: "Aceite de Termos e Políticas",
            programa_dados: {},
            prestador_dados: {},
            loadingDados: true,
            loading: false,
            erro: "",
            prestador_uuid: "",
            optinChecked: false,
            aceitaComunicacoesChecked: false,
            data_aceite_termo: null,
            //termos da plataforma ainda nao assinados; o aceite no formato antigo nao cobre estes
            termosPlataformaPendentes: [],
            // Configuração de campos (apenas para labels customizados)
            camposConfig: [],
            termosDinamicosHabilitado: false,
            termosDinamicosQuestions: [],
            termosDinamicosAnswers: {},
            programaQuery: "",
            indicacaoQuery: "",
            //termos da plataforma que este profissional ja aceitou (com comprovante)
            termosPlataformaAceitos: [],
        };

        this.handleOptinChange = this.handleOptinChange.bind(this);
        this.handleAceitaComunicacoesChange = this.handleAceitaComunicacoesChange.bind(this);
        this.handleSubmitOptin = this.handleSubmitOptin.bind(this);
        this.handleTermoDinamicoChange = this.handleTermoDinamicoChange.bind(this);
    }

    componentDidMount() {
        const uuid = this.props.router.params.uuid;
        const params = new URLSearchParams(window.location.search);
        const programaQuery = params.get('p') || '';
        // termo que vale POR INDICAÇÃO: sem repassar isto à API, o aceite entraria como
        // termo comum do provedor e a indicação continuaria pendente
        const indicacaoQuery = params.get('indicacao') || '';

        if (uuid) {
            this.setState({
                prestador_uuid: uuid,
                programaQuery,
                indicacaoQuery,
                loadingDados: true,
                erro: ''
            });

            this.carregaDadosPrestador(uuid, programaQuery, indicacaoQuery);
        } else {
            this.setState({
                loadingDados: false,
                erro: "UUID do prestador não informado."
            });
        }
    }

    carregaDadosPrestador = async (uuid, programaQuery = '', indicacaoQuery = '') => {
        const config = {
            headers: {
                'X-USERNAME': import.meta.env.VITE_X_USERNAME,
            }
        };

        try {
            // 1. Busca dados do prestador pelo UUID
            const responsePrestador = await api.get(
                `/pessoas/prestadores/uuid/${uuid}/` + (indicacaoQuery ? `?indicacao=${indicacaoQuery}` : ''), config);
            const prestadorDados = responsePrestador.data;

            if (!prestadorDados) {
                this.setState({
                    loadingDados: false,
                    erro: "Prestador não encontrado."
                });
                return;
            }

            // 2. Descobrir o programa vinculado ao prestador
            let programa_id = programaQuery || this.state.programaQuery || prestadorDados.dados_programa?.id || prestadorDados.programa_id;

            // Se não tiver programa direto, busca pelos vínculos
            if (!programa_id) {
                try {
                    const responseVinculos = await api.get(`/programas/prestadores/?prestador_id=${prestadorDados.id}`, config);
                    if (responseVinculos.data?.results?.length > 0) {
                        programa_id = responseVinculos.data.results[0].programa_id;
                    }
                } catch (err) {
                    console.error("Erro ao buscar vínculos do prestador:", err);
                }
            }

            if (!programa_id) {
                this.setState({
                    loadingDados: false,
                    prestador_dados: prestadorDados,
                    data_aceite_termo: (prestadorDados.indicacao
                        ? (prestadorDados.indicacao.data_aceite_termo || null)
                        : (prestadorDados.data_aceite_termo || null)),
                    termosPlataformaPendentes: prestadorDados.termos_plataforma_pendentes || [],
                    erro: "Nenhum programa vinculado encontrado para este prestador."
                });
                return;
            }

            const responsePrograma = await api.get(`/programas/publico/${programa_id}/`, config);
            const programaDados = responsePrograma.data;

            const camposConfig = programaDados.configuracoes?.campos_tela_aceite_termo_novo_medico?.campos || [];
            const termosDinamicosConfig = programaDados.configuracoes?.Termos_Dinamicos || {};
            const termosDinamicosHabilitado = termosDinamicosConfig?.habilitado_termo_dinamico_medico === true;
            //filtradas pela categoria do proprio profissional que abriu o link
            const termosDinamicosQuestions = perguntasDaCategoria(termosDinamicosConfig?.Questions, prestadorDados?.categoria);
            const termosDinamicosAnswers = prestadorDados.termos_dinamicos_respostas_json || {};

            this.setState({
                prestador_dados: prestadorDados,
                programa_dados: programaDados,
                data_aceite_termo: (prestadorDados.indicacao
                    ? (prestadorDados.indicacao.data_aceite_termo || null)
                    : (prestadorDados.data_aceite_termo || null)),
                termosPlataformaPendentes: prestadorDados.termos_plataforma_pendentes || [],
                aceitaComunicacoesChecked: prestadorDados.receber_comunicacoes || false,
                camposConfig: camposConfig,
                termosDinamicosHabilitado,
                termosDinamicosQuestions,
                termosDinamicosAnswers,
                termosPlataformaAceitos: prestadorDados.termos_plataforma_aceitos || [],
                loadingDados: false,
                erro: ''
            });

        } catch (error) {
            console.error('Erro ao carregar dados:', error);

            let erro_msg = "Erro ao carregar dados. Tente novamente.";

            if (error.response?.status === 404) {
                erro_msg = "Prestador não encontrado.";
            } else if (error.response?.status === 500) {
                erro_msg = "Servidor indisponível no momento.";
            }

            this.setState({
                loadingDados: false,
                erro: erro_msg
            });
        }
    };

    handlePdfLoaded = (key) => {
        this.setState((prev) => ({
            loadingPdf: { ...prev.loadingPdf, [key]: false }
        }));
    };

    handleOptinChange(e) {
        this.setState({ optinChecked: e.target.checked });
    }

    handleAceitaComunicacoesChange(e) {
        this.setState({ aceitaComunicacoesChecked: e.target.checked });
    }

    handleTermoDinamicoChange(slug, value) {
        this.setState((prev) => ({
            termosDinamicosAnswers: {
                ...prev.termosDinamicosAnswers,
                [slug]: value
            }
        }));
    }

    handleSubmitOptin() {
        const MySwal = withReactContent(Swal);

        if (!this.state.optinChecked) {
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: 'Atenção!',
                html: 'Você precisa aceitar os termos para continuar'
            });
            return;
        }

        if (this.state.termosDinamicosHabilitado) {
            const erros = [];
            let mensagemBloqueio = '';
            this.state.termosDinamicosQuestions.forEach((q) => {
                if (!q || !q.slug) return;
                const valor = this.state.termosDinamicosAnswers[q.slug];

                if (q.obrigatorio && (valor === undefined || valor === null || valor === '')) {
                    erros.push(q.label || q.slug);
                }

                const regraBloqueio = q.regra_bloqueio_cadastro || {};
                if (regraBloqueio.ativo === true && valor === regraBloqueio.quando_valor) {
                    mensagemBloqueio = regraBloqueio.mensagem || 'Não é possível prosseguir com as opções selecionadas.';
                }
            });

            if (mensagemBloqueio) {
                MySwal.fire({
                    icon: 'error',
                    showCloseButton: true,
                    title: 'Cadastro bloqueado',
                    html: mensagemBloqueio
                });
                return;
            }

            if (erros.length > 0) {
                MySwal.fire({
                    icon: 'error',
                    showCloseButton: true,
                    title: 'Atenção!',
                    html: 'Preencha os campos obrigatórios do formulário de aceite para continuar.'
                });
                return;
            }
        }

        this.setState({ loading: true });

        // sem o 'Z' final: o formatador da tela acrescenta o dele, e '...ZZ' vira
        // Invalid Date. Mesmo formato que a API devolve neste campo.
        const dataAtual = new Date().toISOString().slice(0, 19);
        const config = {
            headers: {
                'X-USERNAME': import.meta.env.VITE_X_USERNAME,
            }
        };

        const payload = {
            data_aceite_termo: dataAtual,
            programa_id: this.state.programa_dados?.id,
            programa_uuid: this.state.programa_dados?.uuid
        };
        
        if (this.state.programa_dados.configuracoes?.aceita_receber_comunicacoes) {
             payload.receber_comunicacoes = this.state.aceitaComunicacoesChecked;
        }

        if (this.state.termosDinamicosHabilitado) {
            payload.termos_dinamicos_respostas_json = this.state.termosDinamicosAnswers;
        }

        // amarra o aceite à indicação daquele link; sem isto o mesmo profissional indicado
        // por dois médicos aceitaria uma vez só
        if (this.state.indicacaoQuery) {
            payload.indicacao_uuid = this.state.indicacaoQuery;
        }

        api.put(`/pessoas/prestadores/uuid/${this.state.prestador_uuid}/`,
            payload,
            config
        )
        .then(() => {
            this.setState({
                loading: false,
                data_aceite_termo: dataAtual,
                optinChecked: false
            });
            MySwal.fire({
                icon: 'success',
                showCloseButton: true,
                title: 'Termos Aceitos!',
                html: 'Os termos foram aceitos com sucesso!'
            }).then((result) => {
                location.reload();
            });
        })
        .catch(error => {
            console.error('Erro ao aceitar termos:', error);
            this.setState({ loading: false });
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: 'Atenção!',
                html: 'Houve um erro ao aceitar os termos. Por favor, tente novamente.'
            });
        });
    }

    renderPdfCard = (title, url, key) => {
        const { loadingPdf } = this.state;

        if (!url) {
            return (
                <Card className="cardDestaque mb-4">
                    <Card.Header>
                        <div>{title}</div>
                    </Card.Header>
                    <Card.Body>
                        <Alert variant="warning" className="m-0">
                            <FaExclamationTriangle className="me-2" />
                            Este documento não foi cadastrado para este programa.
                        </Alert>
                    </Card.Body>
                </Card>
            );
        }

        return (
            <Card className="cardDestaque mb-4">
                <Card.Header className="d-flex justify-content-between align-items-center">
                    <div className="fw-bold">{title}</div>
                    <div>
                        <Button
                            size="sm"
                            variant="outline-primary"
                            href={url}
                            target="_blank"
                            rel="noopener noreferrer"
                            title="Baixar ou Visualizar em nova aba"
                        >
                            <FaDownload className="me-1" /> Baixar / Visualizar
                        </Button>
                    </div>
                </Card.Header>
                <Card.Body style={{ padding: 0 }}>
                    {loadingPdf[key] && (
                        <div style={{ padding: 20, textAlign: "center" }}>
                            <Spinner animation="border" variant="primary" size="sm" />
                            <p className="mt-2 text-muted">Carregando documento...</p>
                        </div>
                    )}

                    <div style={{ width: "100%", height: "75vh", borderTop: "1px solid #eee" }}>
                        <iframe
                            title={title}
                            src={url}
                            style={{ width: "100%", height: "100%", border: "none" }}
                            onLoad={() => this.handlePdfLoaded(key)}
                        />
                    </div>
                </Card.Body>
            </Card>
        );
    };

    getLabelCustomizado = (slugCampo, labelPadrao) => {
        const { camposConfig, programa_dados, prestador_dados } = this.state;
        
        if (camposConfig.length === 0) {
            return labelPadrao;
        }

        const campoConfig = camposConfig.find(c => c.slug === slugCampo);
        if (!campoConfig) {
            return labelPadrao;
        }

        const variables = {
            programa_nome: programa_dados.nome || '',
            programa_id: programa_dados.id || '',
            prestador_nome: prestador_dados.nome || '',
            prestador_id: prestador_dados.id || '',
        };

        return replaceTextVariables(campoConfig.label, variables);
    };

    render() {
        const { programa_dados, prestador_dados, loadingDados, erro, data_aceite_termo, loading, optinChecked, aceitaComunicacoesChecked, termosDinamicosHabilitado, termosDinamicosQuestions, termosDinamicosAnswers } = this.state;

        //quem aceitou no formato antigo tem data_aceite_termo preenchida, mas pode ter termo
        //de plataforma pendente -- ai a tela precisa deixar assinar de novo
        const aceiteConcluido = !!data_aceite_termo && !(this.state.termosPlataformaPendentes || []).length;

        if (loadingDados) {
            return (
                <div className="container">
                    <Row className="mt-5 align-items-center justify-content-center">
                        <Col sm={8} lg={8}>
                            <div className="text-center mt-5">
                                <Spinner animation="border" role="status">
                                    <span className="visually-hidden">Carregando...</span>
                                </Spinner>
                                <p className="mt-2">Carregando termos e políticas...</p>
                            </div>
                        </Col>
                    </Row>
                </div>
            );
        }

        if (erro) {
            return (
                <div className="container">
                    <Row className="mt-5 align-items-center justify-content-center">
                        <Col sm={8} lg={8}>
                            <Alert variant="danger" className="mt-4">
                                <FaExclamationTriangle className="me-2" />
                                {erro}
                            </Alert>
                        </Col>
                    </Row>
                </div>
            );
        }

        // Determina quais tabs mostrar
        const tabsValidas = [];

        if (programa_dados.termos_programa_medicos) {
            tabsValidas.push("dadosTermoMedico");
        }
        if (programa_dados.regulamento_programa) {
            tabsValidas.push("politicaRegulamento");
        }
        if (programa_dados.aviso_privacidade) {
            tabsValidas.push("politicaPrivacidade");
        }
        if (programa_dados.politica_cookies) {
            tabsValidas.push("politicaCookies");
        }

        //aceito pela plataforma, o comprovante e o documento que vale: substitui o termo
        //do programa, que aqui apareceria em branco
        const indicacaoAtual = this.state.prestador_dados?.indicacao;
        const termosPlataformaAceitos = (this.state.termosPlataformaAceitos || [])
            .filter((t) => t.pdf_comprovante)
            //no aceite por indicação vale só o aceite DESTA indicação: o profissional
            //indicado por dois médicos assina uma vez para cada, e o comprovante do
            //primeiro aparecia como se já resolvesse o segundo
            .filter((t) => !indicacaoAtual?.encontrada || t.indicacao_id === indicacaoAtual.id);
        if (termosPlataformaAceitos.length > 0) {
            const indice = tabsValidas.indexOf("dadosTermoMedico");
            if (indice >= 0) tabsValidas.splice(indice, 1);
            tabsValidas.unshift("termoPlataformaAceito");
        }

        const porIndicacao = !!indicacaoAtual?.encontrada;

        //só no aceite POR INDICAÇÃO o termo pendente toma o lugar do documento do programa:
        //fora daí a tela é a do médico comum, de qualquer programa, e trocar o documento
        //dele mudaria o aceite de quem não tem nada a ver com indicação
        const termosPlataformaPendentes = porIndicacao
            ? (this.state.termosPlataformaPendentes || []).filter((t) => t.arquivo_url)
            : [];
        if (termosPlataformaPendentes.length > 0) {
            const indice = tabsValidas.indexOf("dadosTermoMedico");
            if (indice >= 0) tabsValidas.splice(indice, 1);
            tabsValidas.unshift("termoPlataformaPendente");
        }

        //aceite por indicação: só o termo. Regulamento, privacidade e cookies são do
        //programa e não fazem parte do que o profissional indicado precisa assinar
        if (porIndicacao) {
            const manter = termosPlataformaAceitos.length > 0
                ? "termoPlataformaAceito"
                : (termosPlataformaPendentes.length > 0 ? "termoPlataformaPendente" : null);
            if (manter) {
                tabsValidas.length = 0;
                tabsValidas.push(manter);
            }
        }

        const defaultTab = tabsValidas[0] || null;

        return (
            <div className="container">
                <Row className="mt-2 align-items-center justify-content-center">
                    <Col sm={10} lg={10}>
                        {programa_dados.imagem_branca && (
                            <div className="mb-3 text-center">
                                <img src={programa_dados.imagem_branca} alt={programa_dados.nome} style={{ maxWidth: '200px' }} />
                            </div>
                        )}

                        {!aceiteConcluido ? (
                            <h6 className="text-center text-white mb-5">
                                Prezado(a) {prestador_dados.nome ? <strong>{prestador_dados.nome}</strong> : ''}, por favor leia e aceite os termos abaixo:
                            </h6>
                        ) : (
                            <h1 className="page-title title-termo text-center mb-4">
                                Aceite de Termos - {programa_dados.nome || 'Programa'}
                            </h1>
                        )}

                        {tabsValidas.length === 0 ? (
                            <Alert variant="warning">
                                <FaExclamationTriangle className="me-2" />
                                Nenhum documento foi configurado para este programa.
                            </Alert>
                        ) : (
                            <>
                                <Tabs defaultActiveKey={defaultTab} id="tabs-termo-aceite" className="aditus-tabs mb-3">
                                    {termosPlataformaAceitos.length > 0 && (
                                        <Tab eventKey="termoPlataformaAceito" title="Termo Aceito">
                                            <div className="mt-3">
                                                {termosPlataformaAceitos.map((t) => (
                                                    this.renderPdfCard(
                                                        `${t.termo_titulo || 'Termo Aceito'}${t.termo_versao ? ` (v${t.termo_versao})` : ''}`,
                                                        t.pdf_comprovante,
                                                        `plataforma_${t.id}`
                                                    )
                                                ))}
                                            </div>
                                        </Tab>
                                    )}
                                    {/* termo de plataforma pendente tem documento próprio -- é o caso do
                                        profissional indicado, que precisa ler o TCLE dele e não o termo
                                        do médico configurado no programa */}
                                    {termosPlataformaPendentes.length > 0 && (
                                        <Tab eventKey="termoPlataformaPendente" title="Termo para Aceite">
                                            <div className="mt-3">
                                                {termosPlataformaPendentes.map((t) => (
                                                    this.renderPdfCard(
                                                        `${t.titulo || "Termo"}${t.versao ? ` (v${t.versao})` : ""}`,
                                                        t.arquivo_url,
                                                        `pendente_${t.id}`
                                                    )
                                                ))}
                                            </div>
                                        </Tab>
                                    )}
                                    {programa_dados.termos_programa_medicos && termosPlataformaAceitos.length === 0
                                        && termosPlataformaPendentes.length === 0 && !porIndicacao && (
                                        <Tab eventKey="dadosTermoMedico" title="Termos do Programa">
                                            <div className="mt-3">
                                                {this.renderPdfCard("Termos do Programa (Médicos)", programa_dados.termos_programa_medicos, "termo")}
                                            </div>
                                        </Tab>
                                    )}
                                    {programa_dados.regulamento_programa && !porIndicacao && (
                                        <Tab eventKey="politicaRegulamento" title="Regulamento do Programa">
                                            <div className="mt-3">
                                                {this.renderPdfCard("Regulamento do Programa", programa_dados.regulamento_programa, "regulamento")}
                                            </div>
                                        </Tab>
                                    )}
                                    {programa_dados.aviso_privacidade && !porIndicacao && (
                                        <Tab eventKey="politicaPrivacidade" title="Aviso de Privacidade">
                                            <div className="mt-3">
                                                {this.renderPdfCard("Aviso de Privacidade", programa_dados.aviso_privacidade, "privacidade")}
                                            </div>
                                        </Tab>
                                    )}
                                    {programa_dados.politica_cookies && !porIndicacao && (
                                        <Tab eventKey="politicaCookies" title="Políticas de Cookies">
                                            <div className="mt-3">
                                                {this.renderPdfCard("Políticas de Cookies", programa_dados.politica_cookies, "cookies")}
                                            </div>
                                        </Tab>
                                    )}
                                </Tabs>

                                {/* Seção de aceite */}
                                <Card className="cardDestaque mt-4">
                                    <Card.Body>
                                        {aceiteConcluido ? (
                                            <Row className="align-items-center">
                                                <Col sm={12}>
                                                    <Alert variant="success" className="m-0">
                                                        <FaCheck className="me-2" />
                                                        Termos aceitos em <strong>{formataDataHoraExibicao(data_aceite_termo)}</strong>
                                                    </Alert>
                                                </Col>
                                            </Row>
                                        ) : (
                                            <Row>
                                                <Col sm={12}>
                                                    {termosDinamicosHabilitado && termosDinamicosQuestions.length > 0 && (
                                                        <div className="mt-1">
                                                            {termosDinamicosQuestions.map((campo) => {
                                                                if (!campo?.slug) return null;
                                                                const label = replaceTextVariables(campo.label || campo.slug, {
                                                                    programa_nome: programa_dados.nome || '',
                                                                    programa_id: programa_dados.id || '',
                                                                    prestador_nome: prestador_dados.nome || '',
                                                                    prestador_id: prestador_dados.id || '',
                                                                });
                                                                const valor = termosDinamicosAnswers[campo.slug];

                                                                if (campo.tipo === 'checkbox') {
                                                                    return (
                                                                        <div key={campo.slug} className="mt-3">
                                                                            <div className="mb-1"><strong>{label}</strong></div>
                                                                            {campo.texto && (
                                                                                <div className="text-muted mb-2">{campo.texto}</div>
                                                                            )}
                                                                            <Form.Check
                                                                                className="mt-1"
                                                                                type="checkbox"
                                                                                id={`term-din-${campo.slug}`}
                                                                                label={campo.checkbox_label || 'Confirmo'}
                                                                                checked={Boolean(valor)}
                                                                                onChange={(e) => this.handleTermoDinamicoChange(campo.slug, e.target.checked)}
                                                                                style={{ cursor: "pointer" }}
                                                                            />
                                                                            {campo.observacao && (
                                                                                <div className="mt-2 text-muted">{campo.observacao}</div>
                                                                            )}
                                                                        </div>
                                                                    );
                                                                }

                                                                if (campo.tipo === 'radio') {
                                                                    const opcoes = Array.isArray(campo.opcoes) ? campo.opcoes : [];
                                                                    return (
                                                                        <div key={campo.slug} className="mt-3">
                                                                            <div className="mb-1"><strong>{label}</strong></div>
                                                                            {campo.texto && (
                                                                                <div className="text-muted mb-2">{campo.texto}</div>
                                                                            )}
                                                                            {opcoes.map((opcao, idx) => {
                                                                                const opcaoValor = typeof opcao === 'object' ? opcao?.valor : opcao;
                                                                                const opcaoLabel = typeof opcao === 'object' ? (opcao?.label ?? String(opcaoValor)) : String(opcao);
                                                                                return (
                                                                                    <Form.Check
                                                                                        key={`${campo.slug}-${idx}`}
                                                                                        type="radio"
                                                                                        name={`term-din-${campo.slug}`}
                                                                                        id={`term-din-${campo.slug}-${idx}`}
                                                                                        label={opcaoLabel}
                                                                                        checked={valor === opcaoValor}
                                                                                        onChange={() => this.handleTermoDinamicoChange(campo.slug, opcaoValor)}
                                                                                    />
                                                                                );
                                                                            })}
                                                                            {campo.observacao && (
                                                                                <div className="mt-2 text-muted">{campo.observacao}</div>
                                                                            )}
                                                                        </div>
                                                                    );
                                                                }

                                                                if (campo.tipo === 'textarea') {
                                                                    return (
                                                                        <Form.Group key={campo.slug} className="mt-3">
                                                                            <Form.Label><strong>{label}</strong></Form.Label>
                                                                            {campo.texto && (
                                                                                <div className="text-muted mb-2">{campo.texto}</div>
                                                                            )}
                                                                            <Form.Control
                                                                                as="textarea"
                                                                                rows={3}
                                                                                value={valor || ''}
                                                                                onChange={(e) => this.handleTermoDinamicoChange(campo.slug, e.target.value)}
                                                                            />
                                                                            {campo.observacao && (
                                                                                <div className="mt-2 text-muted">{campo.observacao}</div>
                                                                            )}
                                                                        </Form.Group>
                                                                    );
                                                                }

                                                                if (campo.tipo === 'date') {
                                                                    return (
                                                                        <Form.Group key={campo.slug} className="mt-3">
                                                                            <Form.Label><strong>{label}</strong></Form.Label>
                                                                            {campo.texto && (
                                                                                <div className="text-muted mb-2">{campo.texto}</div>
                                                                            )}
                                                                            <Form.Control
                                                                                type="date"
                                                                                value={valor || ''}
                                                                                onChange={(e) => this.handleTermoDinamicoChange(campo.slug, e.target.value)}
                                                                            />
                                                                            {campo.observacao && (
                                                                                <div className="mt-2 text-muted">{campo.observacao}</div>
                                                                            )}
                                                                        </Form.Group>
                                                                    );
                                                                }

                                                                return (
                                                                    <Form.Group key={campo.slug} className="mt-3">
                                                                        <Form.Label><strong>{label}</strong></Form.Label>
                                                                        {campo.texto && (
                                                                            <div className="text-muted mb-2">{campo.texto}</div>
                                                                        )}
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={valor || ''}
                                                                            onChange={(e) => this.handleTermoDinamicoChange(campo.slug, e.target.value)}
                                                                        />
                                                                        {campo.observacao && (
                                                                            <div className="mt-2 text-muted">{campo.observacao}</div>
                                                                        )}
                                                                    </Form.Group>
                                                                );
                                                            })}
                                                        </div>
                                                    )}

                                                    {/* Checkbox condicional de comunicações */}
                                                    {programa_dados.configuracoes?.aceita_receber_comunicacoes && (
                                                        <Form.Check
                                                            className="mt-4"
                                                            type="checkbox"
                                                            id="aceite-comunicacoes"
                                                            label={<strong>{getConfig(programa_dados.configuracoes, "termos_medico.label_aceite_comunicacao", 'Aceito receber comunicações')}</strong>}
                                                            checked={aceitaComunicacoesChecked}
                                                            onChange={this.handleAceitaComunicacoesChange}
                                                            style={{ cursor: "pointer" }}
                                                        />
                                                    )}

                                                    <Form.Check
                                                        className="mt-2"
                                                        type="checkbox"
                                                        id="aceite-termos"
                                                        label={<strong>{getConfig(programa_dados.configuracoes, "termos_medico.label_aceite_termos", 'Li e concordo com todos os Termos e Políticas acima')}</strong>}
                                                        checked={optinChecked}
                                                        onChange={this.handleOptinChange}
                                                        style={{ cursor: "pointer" }}
                                                    />
                                                </Col>
                                                <Col sm={12} className="text-end mt-3">
                                                    <Button
                                                        variant="success"
                                                        disabled={loading || !optinChecked}
                                                        onClick={this.handleSubmitOptin}
                                                    >
                                                        {loading ? (
                                                            <Spinner animation="border" size="sm" />
                                                        ) : (
                                                            <>
                                                                <FaCheck className="me-1" /> Aceitar Termos
                                                            </>
                                                        )}
                                                    </Button>
                                                </Col>
                                            </Row>
                                        )}
                                    </Card.Body>
                                </Card>
                            </>
                        )}

                        {/* Footer */}
                        <div className="mt-5 text-center">
                            <p>
                                Powered by{' '}
                                <a href="https://aditushealth.com.br" target="_blank" rel="noreferrer">
                                    <img src={logomarca} alt="Aditus Health" style={{ maxWidth: '60px' }} />
                                </a>
                            </p>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default withRouter(TermosMedicoAceite);
